import { FC } from "react"
import { wrap } from "@/utils/globals"
import AppEventProviderView from "./views/AppEventProviderView"
import useAppEventProvider, { useAppEventProviderProps } from "./hooks/useAppEventProvider"

const AppEventProvider: FC<useAppEventProviderProps> = wrap(AppEventProviderView, useAppEventProvider)
export default AppEventProvider
